/* eslint object-shorthand: "off"*/

import { useMemo } from 'react';
import useChartCategories from './useChartCategories';
import useChartPlotLines from './useChartPlotLines';
import { getColor } from 'common/constants/_colors';
import { renderToString } from 'react-dom/server';
import Tooltip from './Tooltip';
import useSelectedFilterSet from '../../../../state/filters/hooks/useSelectedFilterSet';
import { ForecastFiltersContext } from '../../../../state/filters/contexts';
import useForecastTrackingEvents from '../../useForecastTrackingEvents';

const useChartConfig = ({ forecast, chartType }) => {
  const trackingEvents = useForecastTrackingEvents();
  const chartTypeConfig = chartType?.getConfig({ forecast });
  const selectedFilterSet = useSelectedFilterSet(ForecastFiltersContext);
  const finishedWeeks = forecast?.finishedWeeks;

  const chartData = useMemo(() => {
    return (
      finishedWeeks?.map(item => {
        return {
          ...item,
          y: Number(chartTypeConfig?.getValue(item))
        };
      }) || []
    );
  }, [finishedWeeks, chartTypeConfig]);

  const xAxisCategories = useChartCategories({ chartData });
  const plotLines = useChartPlotLines({ chartData });

  const series = [{ data: chartData }];

  const graphConfig = {
    chart: {
      type: 'column',
      style: {
        fontFamily: 'Outfit'
      }
    },
    legend: {
      enabled: false
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: xAxisCategories,
      title: {
        text: 'Week (end date)',
        margin: 10
      },
      plotLines
    },
    dataLabels: {
      allowOverlap: true
    },
    yAxis: {
      tickInterval: chartTypeConfig?.yAxis?.getTickInterval?.() || null,
      max: chartTypeConfig?.yAxis?.max || null,
      labels: {
        formatter: function () {
          return chartTypeConfig?.yAxis?.labelFormatter?.(this) || this.value;
        }
      },
      title: ''
    },
    series,
    tooltip: {
      enabled: true,
      useHTML: true,
      backgroundColor: '#FFF',
      stickOnContact: false,
      borderColor: getColor('botticelli'),
      outside: false,
      hideDelay: 0,
      formatter: function () {
        trackingEvents.onHoverColumnChartTooltip(chartType.key);

        return renderToString(
          <Tooltip
            event={this}
            forecast={forecast}
            selectedFilterSet={selectedFilterSet}
          />
        );
      }
    }
  };
  return graphConfig;
};

export default useChartConfig;
